import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const SubjectBasket = () => {
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/subjects").then(setSubjects).catch(() => {});
    apiJson("/api/admin/master/subject-categories").then(setCategories).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Subject Basket Entries"
      apiPath="/api/admin/master/subject-basket"
      columns={[
        { key: "id", label: "ID" },
        { label: "Major Subject", render: (item) => item.majorSubject?.name || "-" },
        { label: "Category", render: (item) => item.subjectCategory?.name || "-" },
        { key: "optionLabel", label: "Option Label" },
        { key: "sortOrder", label: "Sort Order" },
      ]}
      formFields={[
        {
          key: "majorSubjectId",
          label: "Major Subject",
          type: "select",
          required: true,
          options: subjects.map((s) => ({ value: s.id, label: s.name })),
        },
        {
          key: "subjectCategoryId",
          label: "Category",
          type: "select",
          required: true,
          options: categories.map((c) => ({ value: c.id, label: `${c.name} (${c.code})` })),
        },
        { key: "optionLabel", label: "Option Label", required: true },
        { key: "sortOrder", label: "Sort Order", type: "number" },
      ]}
    />
  );
};

export default SubjectBasket;
